import { Observable } from 'rxjs';
export interface IPerson{
  idCompany?:string;
    name?:string ;
    linkedin_link ?:string ;
    website_link  ?:string ;
    type ?:number ;
    email?:string ;
    password?:string ;
    id?:string ;
    first_name ?:string ;
    last_name  ?:string ;
    confirmPassword?:string ;
    terme?: boolean;
    newsLetter?: boolean;
  }
  export class CLogin implements IPerson {
    email: string | undefined;
    password: string | undefined;
    constructor(model?: CLogin) {
        this.email = model && model.email || "";
        this.password = model && model.password || "";
    }
  }
  export class CRegister {
    idCompany:string|undefined;
    name : string| undefined;
    linkedin_link : string| undefined;
    website_link  : string| undefined;
    first_name : string| undefined;
    last_name  : string| undefined;
    type: number | undefined;
    email: string | undefined;  
    password: string | undefined;
    confirmPassword: string | undefined;
    terme: boolean | false;
    newsLetter: boolean | false;
    id: string | undefined;
    constructor(data:IPerson) {
      this.idCompany =data && data.idCompany || "";
      this.name =data && data.name || "";
      this.linkedin_link =data && data.linkedin_link || "";
      this.website_link  =data && data.website_link  || "";
      this.first_name =data && data.first_name || "";
      this.last_name  =data && data.last_name  || "";
      this.type = data && typeof data.type === 'number' ? data.type : 0;
      this.email = data && data.email || "";
      this.password = data && data.password || "";
      this.confirmPassword = data && data.confirmPassword || "";
      this.terme = data && data.terme || false;
      this.newsLetter = data && data.newsLetter || false;
      this.id = data && data.id || "";
    }

  }
  export class CPassoword{
    newPassword: string | undefined;
    email: string | undefined;
    confirmPassword: string | undefined;
    token?:string
    constructor(model?: CPassoword) {
        this.newPassword = model && model.newPassword || "";
        this.email = model && model.email || "";
        this.confirmPassword = model && model.confirmPassword || "";
        this.token=model && model.token || "" ; 
    }
  }
  export class CChangePassoword{
    newPassword: string | undefined;
    email: string | undefined;
    confirmNewPassword: string | undefined;
    oldPassword:string|undefined
    constructor(model?: CChangePassoword) {
        this.newPassword = model && model.newPassword || "";
        this.email = model && model.email || "";
        this.oldPassword = model && model.oldPassword || "";
        this.confirmNewPassword = model && model.confirmNewPassword || "";
    }
  
  }

  